module.exports = __webpack_public_path__ + "8cbbaf8c7511b5b7a08f3e8bd5b270a1.svg";